module.exports = __webpack_public_path__ + "media/src/ui/icons/AVI-e2a18d4e53e02d1c822e2838605e9821.svg";